import React, { useEffect, useState } from "react";
import style from "./psilideo-plague.module.css";

import PsilideoImage from "../../../../images/psilide-colored.png";
import logger from "../../../../utils/logger";

import TotalInformations from "./total-informations/total-informations";
import ParkOutlinedIcon from "@mui/icons-material/ParkOutlined";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

function PsilideoPlague({ plague, infestation, data }) {
  const [samples, setSamples] = useState([]);
  const [unsheet, setUnsheet] = useState();
  const [levelInfestation, setLevelInfestation] = useState("");

  // Validar se plague é um objeto válido (após hooks)
  const isValidPlague = plague && typeof plague === "object" && plague.name && plague.scientific;

  useEffect(() => {
    const amostra = Array.from({ length: 5 }).map((_, index) => ({
      planta: index + 1,
      percentualEggs: 0,
      percentualNinfas: 0,
      percentualNinfasParasited: 0,
    }));
    setSamples(amostra);
  }, []);

  const handleChangeEggs = (index, value) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualEggs = value;
    setSamples(updatedAmostras);
  };

  const handleChangeNinfas = (index, value) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualNinfas = value;
    setSamples(updatedAmostras);
  };

  const handleChangeNinfasParasited = (index, value) => {
    const updatedAmostras = [...samples];
    if (
      updatedAmostras[index].percentualNinfas >
      updatedAmostras[index].percentualNinfasParasited
    ) {
      updatedAmostras[index].percentualNinfasParasited = value;
    }
    setSamples(updatedAmostras);
  };

  const handleChangeInfestation = (information) => {
    let info = information;

    infestation(info);
  };

  const handleClickRemoveEggs = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualEggs -= 1;
    if (updatedAmostras[index].percentualEggs < 0) {
      updatedAmostras[index].percentualEggs = 0;
    }
    setSamples(updatedAmostras);
  };

  const handleClickAddEggs = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualEggs += 1;
    setSamples(updatedAmostras);
  };

  const handleClickRemoveNinfasLife = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualNinfas -= 1;
    if (updatedAmostras[index].percentualNinfas < 0) {
      updatedAmostras[index].percentualNinfas = 0;
    }
    setSamples(updatedAmostras);
  };

  const handleClickAddNinfasLife = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualNinfas += 1;
    setSamples(updatedAmostras);
  };

  const handleClickRemoveNinfasParasited = (index) => {
    const updatedAmostras = [...samples];
    updatedAmostras[index].percentualNinfasParasited -= 1;
    if (
      updatedAmostras[index].percentualNinfasParasited < 0 &&
      updatedAmostras[index].percentualNinfas >
        updatedAmostras[index].percentualNinfasParasited
    ) {
      updatedAmostras[index].percentualNinfasParasited = 0;
    }
    setSamples(updatedAmostras);
  };

  const handleClickAddNinfasParasited = (index) => {
    const updatedAmostras = [...samples];
    if (
      updatedAmostras[index].percentualNinfas >
      updatedAmostras[index].percentualNinfasParasited
    ) {
      updatedAmostras[index].percentualNinfasParasited += 1;
    }
    setSamples(updatedAmostras);
  };

  // Função que calcula o porcentual de ninfas parasitadas
  function parasitismoPorcentual(index) {
    const sample = [...samples];
    let ninfas = parseInt(sample[index].percentualNinfas);
    let parasited = parseInt(sample[index].percentualNinfasParasited);
    let calc = (parasited / ninfas) * 100;

    if (calc >= 0.1 && calc != Infinity) {
      return ((parasited / ninfas) * 100).toFixed(1);
    } else {
      if (calc == Infinity) {
        calc = (parasited / 1) * 100;
        return calc;
      } else {
        return 0;
      }
    }
  }

  useEffect(() => {
    if (data && isValidPlague) {
      data(samples);
    }
  }, [samples, data, isValidPlague]);

  // Retornar null se plague não for válido (após todos os hooks)
  if (!isValidPlague) {
    logger.warn("Objeto de praga inválido:", plague);
    return null;
  }

  return (
    <div>
      <div className={style["card"]}>
        <div className={style["sample-plague"]}>
          <img src={PsilideoImage} />
          <div className={style["name-sample-plague"]}>
            <div>{plague.name}</div>
            <div>{plague.scientific}</div>
          </div>
        </div>

        <div className={style["samples"]}>
          {samples.map((sample, index) => (
            <div className={style["collected-sample-title"]} key={index}>
              <div className={style["collected-sample-plant"]}>
                <div className={style["collected-sample-plant-number"]}>
                  {index + 1}° <ParkOutlinedIcon style={{ width: "0.8rem" }} />
                </div>
              </div>
              <div className={style["psilideo-informations"]}>
                <div className={style["information-unsheet"]}>
                  <div className={style["name"]}> N° de Ovos </div>
                  <div className={style["container-inputs"]}>
                    <RemoveIcon
                      onClick={(e) => handleClickRemoveEggs(index)}
                      className={style["icon"]}
                    />
                    <input
                      value={sample.percentualEggs}
                      className={style["input"]}
                      type="number"
                      onChange={(e) => handleChangeEggs(index, e.target.value)}
                    ></input>
                    <AddIcon
                      onClick={(e) => handleClickAddEggs(index)}
                      className={style["icon"]}
                    />
                  </div>
                </div>

                <div className={style["information-unsheet"]}>
                  <div className={style["name"]}> N° de Ninfas Vivas </div>

                  <div className={style["container-inputs"]}>
                    <RemoveIcon
                      onClick={(e) => handleClickRemoveNinfasLife(index)}
                      className={style["icon"]}
                    />
                    <input
                      value={sample.percentualNinfas}
                      className={style["input"]}
                      type="number"
                      onChange={(e) =>
                        handleChangeNinfas(index, e.target.value)
                      }
                    ></input>
                    <AddIcon
                      onClick={(e) => handleClickAddNinfasLife(index)}
                      className={style["icon"]}
                    />
                  </div>
                </div>

                <div className={style["information-unsheet"]}>
                  <div className={style["name"]}>
                    {" "}
                    N° de Ninfas Parasitadas{" "}
                  </div>

                  <div className={style["container-inputs"]}>
                    <RemoveIcon
                      onClick={(e) => handleClickRemoveNinfasParasited(index)}
                      className={style["icon"]}
                    />
                    <input
                      value={sample.percentualNinfasParasited}
                      className={style["input"]}
                      type="number"
                      onChange={(e) =>
                        handleChangeNinfasParasited(index, e.target.value)
                      }
                    ></input>
                    <AddIcon
                      onClick={(e) => handleClickAddNinfasParasited(index)}
                      className={style["icon"]}
                    />
                  </div>
                </div>

                <div className={style["information-unsheet-percentual"]}>
                  <div className={style["title-percentual"]}>
                    % de Parasitismo
                  </div>
                  <div className={style["percentual"]}>
                    {parasitismoPorcentual(index)}%
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TotalInformations
        samples={samples}
        infestation={handleChangeInfestation}
      />
    </div>
  );
}

export default PsilideoPlague;
